import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link, useHistory } from "react-router-dom";
import Diamond from '../../../../../Assets/adore-imgs/start-with-diamond.jpg'
import setting from '../../../../../Assets/adore-imgs/start-with-setting.jpg'


const DesignDiamondRing = () => {
  const history = useHistory();
  const settings = {
    customPaging: function (i) {
      return <a className="dots11">{i + 1}</a>;
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="RingBuilderHome design-diamond-ring-section">
      <Container fluid className="showcase-container">
        <Row className="align-items-center">
          <Col>
          <div className="py-lg-5">
            <p>Adore Bijoux Jewelers specializes in bespoke jewelry, engagement rings, bridal jewelry, and wedding bands. For over 15 years, we've been dedicated to crafting exquisite, generational pieces with unparalleled attention to detail and personalized service. Our curated collections and private shopping experience offer an intimate touch, ensuring every moment with us is as special as the jewelry we create. Schedule your exclusive appointment today, and let us bring your vision to life.</p>
          </div>
          </Col>
          <Col md={12} xs={12}>
            <div className="textBox">
              <Heading className="text-center">
                <h2>Design your Own Diamond Ring</h2>
              </Heading>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div className="text-center">
            <Image src={Diamond} alt="start with diamond Image" className="img-fluid"/>
             <div className="content mt-4">
              <p className="text-center">Choose from the huge range of Diamonds available</p>
                  <button   onClick={()=> history.push("/diamonds")} className="button_black_border">
                    Start with a diamond{" "}
                  </button>
                </div>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div className="text-center">
            <Image src={setting} alt="start with Setting Image" className="img-fluid"/>
             <div className="content mt-4 text-center">
              <p className="text-center">Select a setting to make your desired Engagement Ring.</p>
                  <button className="button_black_border"
                    onClick={()=> history.push("/ringsettings")}
                  >
                    Start with a setting
                  </button>
                </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DesignDiamondRing;
